import HelperMixin from '../../../Shared/HelperMixin.vue';
import ApexCharts from 'apexcharts';

export default {
    name: 'Events',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (!this.requireUserType([1, 2, 3])) return; else {
                this.loadEventsData();
            }
        } else {
            this.logout();
        }

        window.scrollTo(0, 0);
    },

    data() {
        return {
            loading: true,
            error: null,
            events: null,
            loginDetails: null,
            selectedMonth: new Date().getMonth() + 1,
            topCities: [],
            topCitiesLoading: false,
            charts: {
                tripStatus: null,
                incomeSparkline: null,
                expenseSparkline: null,
                yearToDateSparkline: null,
                yearlyBreakup: null,
                monthlyEarnings: null,
                topCities: null,
                yearlySales: null,
                appActivity: null,
                passengersSparkline: null,
                driversSparkline: null,
                revenueByCategory: null,
                salesOverview: null
            },
            rtlChartDefaults: {
                chart: {
                    fontFamily: 'inherit',
                    foreColor: '#adb0bb',
                    defaultLocale: 'ar',
                    locales: [{
                        name: 'ar',
                        options: {
                            months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
                                     'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
                            shortMonths: ['ينا', 'فبر', 'مار', 'أبر', 'ماي', 'يون',
                                          'يول', 'أغس', 'سبت', 'أكت', 'نوف', 'ديس'],
                            days: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
                            shortDays: ['أحد', 'اثن', 'ثلا', 'أرب', 'خمي', 'جمع', 'سبت']
                        }
                    }]
                },
                tooltip: { 
                    theme: 'dark',
                    style: { fontSize: '12px' } 
                },
                yaxis: { opposite: true },
                legend: { position: 'bottom' }
            },
            arabicMonths: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
                          'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
            monthOptions: [
                { value: 1, label: 'يناير' },
                { value: 2, label: 'فبراير' },
                { value: 3, label: 'مارس' },
                { value: 4, label: 'أبريل' },
                { value: 5, label: 'مايو' },
                { value: 6, label: 'يونيو' },
                { value: 7, label: 'يوليو' },
                { value: 8, label: 'أغسطس' },
                { value: 9, label: 'سبتمبر' },
                { value: 10, label: 'أكتوبر' },
                { value: 11, label: 'نوفمبر' },
                { value: 12, label: 'ديسمبر' }
            ]
        };
    },

    beforeDestroy() {
        Object.values(this.charts).forEach(chart => {
            if (chart) chart.destroy();
        });
    },

    methods: {
        async loadEventsData() {
            this.loading = true;
            this.error = null;
            try {
                const response = await this.$http.GetDashboardEvents();
                this.events = response.data;
                await this.loadTopCities(this.selectedMonth);
                this.$nextTick(() => { this.initCharts(); });
            } catch (e) {
                this.error = 'حدث خطأ في تحميل البيانات';
                console.error(e);
            } finally {
                this.loading = false;
            }
        },

        async loadTopCities(month) {
            this.topCitiesLoading = true;
            try {
                const response = await this.$http.GetDashboardTopCities(month);
                this.topCities = response.data || [];
                this.$nextTick(() => { this.initTopCitiesChart(); });
            } catch (e) {
                console.error('Error loading top cities:', e);
                this.topCities = [];
            } finally {
                this.topCitiesLoading = false;
            }
        },

        onMonthChange() {
            this.loadTopCities(this.selectedMonth);
        },

        initCharts() {
            if (!this.events) return;
            this.initTripStatusChart();
            this.initIncomeSparklineChart();
            this.initExpenseSparklineChart();
            this.initYearToDateSparklineChart();
            this.initYearlyBreakupChart();
            this.initMonthlyEarningsChart();
            this.initTopCitiesChart();
            this.initYearlySalesChart();
            this.initAppActivityChart();
            this.initPassengersSparklineChart();
            this.initDriversSparklineChart();
            this.initRevenueByCategoryChart();
            this.initSalesOverviewChart();
        },

        initTripStatusChart() {
            const el = document.querySelector('#trip-status');
            if (!el || !this.events?.todayTripStatus) return;

            const status = this.events.todayTripStatus;
            const options = {
                chart: { type: 'donut', height: 200, ...this.rtlChartDefaults.chart },
                series: [status.pending || 0, status.accepted || 0, status.started || 0, status.completed || 0, status.cancelled || 0],
                labels: ['معلقة', 'مقبولة', 'بدأت', 'مكتملة', 'ملغاة'],
                colors: ['#FFAE1F', '#49BEFF', '#5D87FF', '#13DEB9', '#FA896B'],
                legend: { position: 'bottom', horizontalAlign: 'center' },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '70%',
                            labels: {
                                show: true,
                                total: { show: true, label: 'الإجمالي', formatter: () => this.events.todayTotalTrips || 0 }
                            }
                        }
                    }
                },
                dataLabels: { enabled: false },
                tooltip: this.rtlChartDefaults.tooltip
            };

            if (this.charts.tripStatus) this.charts.tripStatus.destroy();
            this.charts.tripStatus = new ApexCharts(el, options);
            this.charts.tripStatus.render();
        },

        initIncomeSparklineChart() {
            const el = document.querySelector('#income-sparkline');
            if (!el || !this.events?.incomeCard) return;

            const data = this.events.incomeCard.last7DaysData || [0, 0, 0, 0, 0, 0, 0];
            const options = {
                chart: { type: 'line', height: 60, sparkline: { enabled: true }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'الدخل', data: data }],
                stroke: { curve: 'smooth', width: 2 },
                colors: ['#13DEB9'],
                tooltip: {
                    ...this.rtlChartDefaults.tooltip,
                    fixed: { enabled: true, position: 'right' },
                    y: { formatter: (val) => val.toLocaleString('en-US') + ' د.ل' }
                }
            };

            if (this.charts.incomeSparkline) this.charts.incomeSparkline.destroy();
            this.charts.incomeSparkline = new ApexCharts(el, options);
            this.charts.incomeSparkline.render();
        },

        initExpenseSparklineChart() {
            const el = document.querySelector('#expense-sparkline');
            if (!el || !this.events?.expenseCard) return;

            const data = this.events.expenseCard.last7DaysData || [0, 0, 0, 0, 0, 0, 0];
            const options = {
                chart: { type: 'line', height: 60, sparkline: { enabled: true }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'المصروفات', data: data }],
                stroke: { curve: 'smooth', width: 2 },
                colors: ['#FA896B'],
                tooltip: {
                    ...this.rtlChartDefaults.tooltip,
                    fixed: { enabled: true, position: 'right' },
                    y: { formatter: (val) => val.toLocaleString('en-US') + ' د.ل' }
                }
            };

            if (this.charts.expenseSparkline) this.charts.expenseSparkline.destroy();
            this.charts.expenseSparkline = new ApexCharts(el, options);
            this.charts.expenseSparkline.render();
        },

        initYearToDateSparklineChart() {
            const el = document.querySelector('#year-to-date-sparkline');
            if (!el || !this.events?.yearToDateCard) return;

            const data = this.events.yearToDateCard.last7DaysData || [0, 0, 0, 0, 0, 0, 0];
            const options = {
                chart: { type: 'line', height: 60, sparkline: { enabled: true }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'السنة الحالية', data: data }],
                stroke: { curve: 'smooth', width: 2 },
                colors: ['#5D87FF'],
                tooltip: {
                    ...this.rtlChartDefaults.tooltip,
                    fixed: { enabled: true, position: 'right' },
                    y: { formatter: (val) => val.toLocaleString('en-US') + ' د.ل' }
                }
            };

            if (this.charts.yearToDateSparkline) this.charts.yearToDateSparkline.destroy();
            this.charts.yearToDateSparkline = new ApexCharts(el, options);
            this.charts.yearToDateSparkline.render();
        },

        initYearlyBreakupChart() {
            const el = document.querySelector('#yearly-breakup');
            if (!el || !this.events?.yearlyRevenueByType) return;

            const data = this.events.yearlyRevenueByType;
            const options = {
                chart: { type: 'donut', height: 200, ...this.rtlChartDefaults.chart },
                series: data.map(r => r.revenue || 0),
                labels: data.map(r => r.typeName || ''),
                colors: ['#5D87FF', '#49BEFF', '#FFAE1F', '#FA896B'],
                legend: { position: 'bottom', horizontalAlign: 'center' },
                plotOptions: { pie: { donut: { size: '70%' } } },
                dataLabels: { enabled: false },
                tooltip: {
                    ...this.rtlChartDefaults.tooltip,
                    y: { formatter: (val) => val.toLocaleString('en-US') + ' د.ل' }
                }
            };

            if (this.charts.yearlyBreakup) this.charts.yearlyBreakup.destroy();
            this.charts.yearlyBreakup = new ApexCharts(el, options);
            this.charts.yearlyBreakup.render();
        },

        initMonthlyEarningsChart() {
            const el = document.querySelector('#monthly-earnings');
            if (!el || !this.events) return;

            const data = this.events.last6MonthsProfit || [0, 0, 0, 0, 0, 0];
            const options = {
                chart: { type: 'area', height: 80, sparkline: { enabled: true }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'الأرباح', data: data }],
                stroke: { curve: 'smooth', width: 2 },
                fill: { type: 'gradient', gradient: { shadeIntensity: 0, inverseColors: false, opacityFrom: 0.2, opacityTo: 0.1, stops: [100] } },
                colors: ['#5D87FF'],
                tooltip: {
                    ...this.rtlChartDefaults.tooltip,
                    fixed: { enabled: true, position: 'right' },
                    y: { formatter: (val) => val.toLocaleString('en-US') + ' د.ل' }
                }
            };

            if (this.charts.monthlyEarnings) this.charts.monthlyEarnings.destroy();
            this.charts.monthlyEarnings = new ApexCharts(el, options);
            this.charts.monthlyEarnings.render();
        },

        initTopCitiesChart() {
            const el = document.querySelector('#top-cities');
            if (!el) return;

            const cities = this.topCities || [];
            const options = {
                chart: { type: 'bar', height: 300, toolbar: { show: false }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'عدد الرحلات', data: cities.map(c => c.tripCount || 0) }],
                xaxis: { categories: cities.map(c => c.cityName || ''), labels: { style: { fontSize: '13px', colors: '#adb0bb' } } },
                plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: '60%' } },
                colors: ['#5D87FF'],
                dataLabels: { enabled: false },
                yaxis: { opposite: true },
                tooltip: { ...this.rtlChartDefaults.tooltip, y: { formatter: (val) => val + ' رحلة' } }
            };

            if (this.charts.topCities) this.charts.topCities.destroy();
            this.charts.topCities = new ApexCharts(el, options);
            this.charts.topCities.render();
        },

        initYearlySalesChart() {
            const el = document.querySelector('#yearly-sales');
            if (!el || !this.events) return;

            const revenue = this.events.monthlyRevenue || Array(12).fill(0);
            const expenses = this.events.monthlyExpenses || Array(12).fill(0);

            const options = {
                chart: { type: 'bar', height: 350, toolbar: { show: false }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'الإيرادات', data: revenue }, { name: 'المصروفات', data: expenses }],
                xaxis: { categories: this.arabicMonths, labels: { style: { fontSize: '13px', colors: '#adb0bb' } } },
                plotOptions: { bar: { horizontal: false, columnWidth: '50%', borderRadius: 4 } },
                colors: ['#5D87FF', '#FA896B'],
                dataLabels: { enabled: false },
                legend: { position: 'bottom' },
                yaxis: { opposite: true, labels: { formatter: (val) => val.toLocaleString('en-US') } },
                tooltip: { ...this.rtlChartDefaults.tooltip, y: { formatter: (val) => val.toLocaleString('en-US') + ' د.ل' } }
            };

            if (this.charts.yearlySales) this.charts.yearlySales.destroy();
            this.charts.yearlySales = new ApexCharts(el, options);
            this.charts.yearlySales.render();
        },

        initAppActivityChart() {
            const el = document.querySelector('#app-activity');
            if (!el || !this.events) return;

            const acceptanceRate = this.events.acceptanceRate || 0;
            const options = {
                chart: { type: 'radialBar', height: 150, ...this.rtlChartDefaults.chart },
                series: [acceptanceRate],
                labels: ['نسبة القبول'],
                colors: ['#5D87FF'],
                plotOptions: {
                    radialBar: {
                        hollow: { size: '60%' },
                        dataLabels: { name: { fontSize: '12px', offsetY: 5 }, value: { fontSize: '16px', formatter: (val) => val.toFixed(0) + '%' } }
                    }
                }
            };

            if (this.charts.appActivity) this.charts.appActivity.destroy();
            this.charts.appActivity = new ApexCharts(el, options);
            this.charts.appActivity.render();
        },

        initPassengersSparklineChart() {
            const el = document.querySelector('#passengers-sparkline');
            if (!el || !this.events?.passengersMiniCard) return;

            const data = this.events.passengersMiniCard.last7DaysData || [0, 0, 0, 0, 0, 0, 0];
            const options = {
                chart: { type: 'line', height: 60, sparkline: { enabled: true }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'الركاب', data: data }],
                stroke: { curve: 'smooth', width: 2 },
                colors: ['#5D87FF'],
                tooltip: { ...this.rtlChartDefaults.tooltip, fixed: { enabled: true, position: 'right' }, y: { formatter: (val) => val + ' راكب' } }
            };

            if (this.charts.passengersSparkline) this.charts.passengersSparkline.destroy();
            this.charts.passengersSparkline = new ApexCharts(el, options);
            this.charts.passengersSparkline.render();
        },

        initDriversSparklineChart() {
            const el = document.querySelector('#drivers-sparkline');
            if (!el || !this.events?.driversMiniCard) return;

            const data = this.events.driversMiniCard.last7DaysData || [0, 0, 0, 0, 0, 0, 0];
            const options = {
                chart: { type: 'bar', height: 60, sparkline: { enabled: true }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'السائقين', data: data }],
                plotOptions: { bar: { columnWidth: '60%', borderRadius: 2 } },
                colors: ['#49BEFF'],
                tooltip: { ...this.rtlChartDefaults.tooltip, fixed: { enabled: true, position: 'right' }, y: { formatter: (val) => val + ' سائق' } }
            };

            if (this.charts.driversSparkline) this.charts.driversSparkline.destroy();
            this.charts.driversSparkline = new ApexCharts(el, options);
            this.charts.driversSparkline.render();
        },

        initRevenueByCategoryChart() {
            const el = document.querySelector('#revenue-by-category');
            if (!el || !this.events) return;

            const group1 = this.events.categoryGroup1Revenue || [0, 0, 0, 0, 0, 0];
            const group2 = this.events.categoryGroup2Revenue || [0, 0, 0, 0, 0, 0];
            const currentMonth = new Date().getMonth();
            const last6Months = [];
            for (let i = 5; i >= 0; i--) {
                const monthIndex = (currentMonth - i + 12) % 12;
                last6Months.push(this.arabicMonths[monthIndex]);
            }

            const options = {
                chart: { type: 'bar', height: 300, toolbar: { show: false }, ...this.rtlChartDefaults.chart },
                series: [{ name: 'كلاسيك/فاخرة/نسائية', data: group1 }, { name: 'مشتركة/طلاب/مدارس', data: group2 }],
                xaxis: { categories: last6Months, labels: { style: { fontSize: '13px', colors: '#adb0bb' } } },
                plotOptions: { bar: { horizontal: false, columnWidth: '50%', borderRadius: 4 } },
                colors: ['#5D87FF', '#FFAE1F'],
                dataLabels: { enabled: false },
                legend: { position: 'bottom' },
                yaxis: { opposite: true, labels: { formatter: (val) => val.toLocaleString('en-US') } },
                tooltip: { ...this.rtlChartDefaults.tooltip, y: { formatter: (val) => val.toLocaleString('en-US') + ' د.ل' } }
            };

            if (this.charts.revenueByCategory) this.charts.revenueByCategory.destroy();
            this.charts.revenueByCategory = new ApexCharts(el, options);
            this.charts.revenueByCategory.render();
        },

        initSalesOverviewChart() {
            const el = document.querySelector('#sales-overview');
            if (!el || !this.events) return;

            const completionRate = this.events.completionRatePercent || 0;
            const satisfactionRate = this.events.satisfactionRatePercent || 0;
            const driverActivity = this.events.driverActivityPercent || 0;

            const options = {
                chart: { type: 'radialBar', height: 300, ...this.rtlChartDefaults.chart },
                series: [completionRate, satisfactionRate, driverActivity],
                labels: ['اكتمال الرحلات', 'رضا الركاب', 'نشاط السائقين'],
                colors: ['#5D87FF', '#49BEFF', '#FFAE1F'],
                plotOptions: {
                    radialBar: {
                        hollow: { size: '40%' },
                        dataLabels: {
                            name: { fontSize: '14px' },
                            value: { fontSize: '16px', formatter: (val) => val.toFixed(0) + '%' },
                            total: { show: true, label: 'المتوسط', formatter: () => { const avg = (completionRate + satisfactionRate + driverActivity) / 3; return avg.toFixed(0) + '%'; } }
                        }
                    }
                },
                legend: { show: true, position: 'bottom' }
            };

            if (this.charts.salesOverview) this.charts.salesOverview.destroy();
            this.charts.salesOverview = new ApexCharts(el, options);
            this.charts.salesOverview.render();
        },

        formatNumber(num) {
            if (num === null || num === undefined) return '0';
            return num.toLocaleString('en-US');
        },

        formatCurrency(num) {
            if (num === null || num === undefined) return '0 د.ل';
            return num.toLocaleString('en-US') + ' د.ل';
        },

        formatPercent(num) {
            if (num === null || num === undefined) return '0%';
            const sign = num >= 0 ? '+' : '';
            return sign + num.toFixed(1) + '%';
        },

        formatEventTime(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            return date.toLocaleTimeString('ar-LY', { hour: '2-digit', minute: '2-digit' });
        },

        formatEventDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            return date.toLocaleDateString('ar-LY', { year: 'numeric', month: 'short', day: 'numeric' });
        },

        getEventTypeLabel(eventType) {
            const labels = {
                'trip_created': 'رحلة جديدة',
                'trip_completed': 'رحلة مكتملة',
                'trip_cancelled': 'رحلة ملغاة',
                'driver_registered': 'سائق جديد',
                'passenger_registered': 'راكب جديد'
            };
            return labels[eventType] || eventType;
        },

        getEventBadgeClass(eventType) {
            const classes = {
                'trip_created': 'border-primary',
                'trip_completed': 'border-success',
                'trip_cancelled': 'border-danger',
                'driver_registered': 'border-warning',
                'passenger_registered': 'border-info'
            };
            return classes[eventType] || 'border-secondary';
        },

        getEventTextClass(eventType) {
            const classes = {
                'trip_created': 'text-primary',
                'trip_completed': 'text-success',
                'trip_cancelled': 'text-danger',
                'driver_registered': 'text-warning',
                'passenger_registered': 'text-info'
            };
            return classes[eventType] || 'text-secondary';
        }
    }
};
